import React, { useState } from 'react'

import {
    Button,
    TextField,
    MenuItem,
    Dialog,
    DialogContent,
    DialogTitle,
    Divider,
    Box
} from '@mui/material'

import LoadingButton from '@mui/lab/LoadingButton'
import CloseIcon from '@mui/icons-material/Close'

export default function AddBotDialog({
    open,
    handleClose,
    submit,
    version,
    managedPages
}) {
    const [pageId, setPageId] = useState('');

    const handleSubmit = () => {
        submit(pageId);
    };

    return (
        <div>
            <Dialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
                disablePortal
                disableEnforceFocus
                sx={{ position: 'absolute' }}
            >
                <DialogTitle className="group-flexbox">
                    Adicionar Página
                    <Button
                        sx={{ minWidth: '2rem', padding: 0 }}
                        onClick={handleClose}
                    >
                        <CloseIcon />
                    </Button>
                </DialogTitle>

                <Divider />

                <DialogContent className="add-bot-dialog-content">
                    {version === 1 ? (
                        <TextField
                            select
                            size="small"
                            label="Página"
                            fullWidth
                            variant="outlined"
                            value={pageId}
                            onChange={(e) => setPageId(e.target.value)}
                        >
                            {managedPages.map((page) => (
                                <MenuItem key={page.id} value={page.id}>
                                    {page.name}
                                </MenuItem>
                            ))}
                        </TextField>
                    ) : (
                        <TextField
                            size="small"
                            label="Identificador da Página"
                            fullWidth
                            type="text"
                            variant="outlined"
                            value={pageId}
                            onChange={(e) => setPageId(e.target.value)}
                        />
                    )}

                    <Box className="user-footer">
                        <LoadingButton
                            className="button-created"
                            onClick={handleClose}
                        >
                            Cancelar
                        </LoadingButton>

                        <LoadingButton
                            className="button-created"
                            onClick={handleSubmit}
                            disabled={!pageId}
                        >
                            Salvar
                        </LoadingButton>
                    </Box>
                </DialogContent>
            </Dialog>
        </div>
    );
}
